import { theme } from '@styles';

export const customResponsiveStylesForSelect = {
  width: '210px',

  [theme.breakpoints.down('xl')]: {
    width: '160px',
  },
};
